import API from "..";

export default class BatchAppearance {

  constructor({
    name,
    isActive
  }) 
    
  {
    this.name = name;
    this.isActive = isActive;
  }

  static async getAllBatchAppearances() {
    const api = await API();
    const { data } = await api.get(`/batchAppearance`);
    if (data.result) {
        return data.result.map((d) => new BatchAppearance(d));
    }
    else {
        return [];
    }
  }
}
